import * as React from "react";
import "./OverviewPage.css";
import "../../style/fonts.css";
import CtaButton from "../ctaButton/ctaButton";
import FollowList from "../followList/followList";
import translate from "../../translations/i18n";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import { getVal, firestoreConnect } from "react-redux-firebase";
import { compose } from "redux";
import BackgroundImage1x from "../../icons/webapp_background_stage/webapp_background_stage.png";
import BackgroundImage2x from "../../icons/webapp_background_stage/webapp_background_stage@2x.png";
import BackgroundImage3x from "../../icons/webapp_background_stage/webapp_background_stage@3x.png";

export interface Props {
  followList: any;
  ownAuth: any;
}

class OverviewPage extends React.Component<Props, any> {
  constructor(props: Props) {
    super(props);
  }

  render() {
    console.log();
    return (
      <div className="OVERVIEW_CONT">
        <div className="OVERVIEW_BACKGROUND_IMAGE">
          <img
            src={BackgroundImage1x}
            srcSet={`${BackgroundImage1x} 1x, ${BackgroundImage2x} 2x, ${BackgroundImage3x} 3x`}
          />
        </div>
        <div className="OVERVIEW_CONT_CENTER">
          <div className="OVERVIEW_CONT_TEXT">
            <div className="OVERVIEW_HEADLINE">
              <div className="OVERVIEW_TITLE">
                <div className="TITLE_1">
                  {translate("SUPPORT_OTHERS_SECTION_TITLE")}
                </div>
              </div>
              <div className="OVERVIEW_SUBTITLE">
                <div className="TITLE_3">
                  {translate("SUPPORT_OTHERS_SECTION_SUBTITLE")}
                </div>
              </div>
              <hr className="OVERVIEW_SEPERATOR" />
            </div>
            <div className="OVERVIEW_TEXT">
              <div className="REG_TEXT" style={{ textAlign: "left" }}>
                {translate("SUPPORT_OTHERS_SECTION_TEXT")}
              </div>
            </div>
          </div>

          <div className="FOLLOW_LIST_CONT_OVERVIEW">
            <FollowList followList={this.props.followList} />
          </div>
          <div className="OVERVIEW_SEARCH_BUTTON_CONT">
            <div className="SEARCH_BUTTON_TITLE">
              <div className="SMALL_TEXT1">
                {translate("CTA_ADD_SUPPORT_USER_TITLE")}
              </div>
            </div>
            <div className="SEARCH_BUTTON_CONTAINER">
              <Link to="/search">
                <CtaButton
                  width={"280px"}
                  text={translate("CTA_ADD_SUPPORT_USER")}
                  color={"blue"}
                />
              </Link>
            </div>
            {!this.props.ownAuth.uid && (
              <div className="OVERVIEW_TERTIARY_BUTTON">
                <Link to="/login" className="TITLE_3">
                  {translate("CTA_LOGIN")}
                </Link>
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    followList: getVal(
      state.firestore,
      `data/follow[${state.firebase.auth.uid}].users`
    ),
    ownAuth: state.firebase.auth,
  };
};

export default compose<any>(
  connect(mapStateToProps),
  firestoreConnect((props) => [
    { collection: "follow", doc: props.ownAuth.uid },
  ])
)(OverviewPage);



// WEBPACK FOOTER //
// ./src/components/overview/OverviewPage.tsx